import { ComunicacionAjax } from "../../../ts/api/comunicacion";


export function CambiarContrasenaPage() {
	const onSubmit = (e: React.FormEvent) => {
		const urlParams = new URLSearchParams(window.location.search);
		const token = urlParams.get("token");

		e.preventDefault();

		const form = e.target as HTMLFormElement;

		const password = (form.elements.namedItem("password") as HTMLInputElement).value;
		const repitePassword = (form.elements.namedItem("repitePassword") as HTMLInputElement).value;

		if (password != repitePassword) {
			alert("Las contraseñas no coinciden");
			return "Las contraseñas no coinciden";
		}

		ComunicacionAjax.sendAjaxRequest("POST", "/api/v1/cambiarContrasena", {
			password: password,
			repitePassword: repitePassword,
			token: token,
		}).then(() => {
			alert("Contraseña cambiada correctamente");
			location.href = "/login";
		}).catch((err: unknown) => {
			alert("Error al cambiar la contraseña");
			console.error(err);
		});
	};

	return (
		<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
			<title>Almacen | Cambiar Contraseña</title>
			<div className="login content-box">
				<div className="biggest-box" style={{ textAlign: "center" }}>
					<img src="/img/logoAlmacen.svg" style={{ width: "auto" }} height="240px" />
				</div>
				<div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
					<div style={{ flex: 0.25 }} />
					<div>
						<h4 className="text-center">Introduzca la nueva contraseña</h4>
						<form role="form" className="form" onSubmit={onSubmit}>
							<div className="form-group">
								<input type="password" className="form-control" placeholder="Nueva contraseña" name="password" />
							</div>
							<div className="form-group">
								<input type="password" className="form-control" placeholder="Repite contraseña" name="repitePassword" />
							</div>
							<button type="submit" className="btnPrimary" style={{ width: "100%" }}>
								Cambiar contraseña
							</button>
						</form>
					</div>
					<div style={{ flex: 0.75 }} />
				</div>
			</div>
		</div>
	);
}
